/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
import EventEmitter from 'events';
var IMS_EVENTS;
(function (IMS_EVENTS) {
    IMS_EVENTS["READY"] = "imsReady";
    IMS_EVENTS["ERROR"] = "imsError";
    IMS_EVENTS["TOKEN_AVAILABLE"] = "imsTokenAvailable";
    IMS_EVENTS["TOKEN_EXPIRED"] = "imsTokenExpired";
    IMS_EVENTS["REAUTH_TOKEN"] = "imsReauthAccessToken";
    IMS_EVENTS["LOGOUT"] = "imsLogout";
})(IMS_EVENTS || (IMS_EVENTS = {}));
var imsEvents = new EventEmitter();
export default imsEvents;
export { imsEvents, IMS_EVENTS };
